// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__Vji8e","head":"Table_head__t5Jtg","col":"Table_col__1Vp2B"};